import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api/crm`;
const c = axios.create({ baseURL: API });
c.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("crm_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
export const crm = {
  login: (email, password) => c.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => c.get("/auth/me").then((r) => r.data),
  forgot: (email) => c.post("/auth/forgot-password", { email }).then((r) => r.data),
  reset: (token, password) => c.post("/auth/reset-password", { token, password }).then((r) => r.data),
  employees: () => c.get("/employees").then((r) => r.data),
  createEmployee: (b) => c.post("/employees", b).then((r) => r.data),
  updateEmployee: (id, b) => c.put(`/employees/${id}`, b).then((r) => r.data),
  toggleEmployee: (id) => c.post(`/employees/${id}/toggle`).then((r) => r.data),
  leads: (params) => c.get("/leads", { params }).then((r) => r.data),
  lead: (id) => c.get(`/leads/${id}`).then((r) => r.data),
  createLead: (b) => c.post("/leads", b).then((r) => r.data),
  updateLead: (id, b) => c.put(`/leads/${id}`, b).then((r) => r.data),
  checkDup: (mobile) => c.get("/leads/check-duplicate", { params: { mobile } }).then((r) => r.data),
  assign: (b) => c.post("/leads/assign", b).then((r) => r.data),
  bulkStatus: (b) => c.post("/leads/bulk-status", b).then((r) => r.data),
  addInteraction: (b) => c.post("/interactions", b).then((r) => r.data),
  interactions: (params) => c.get("/interactions", { params }).then((r) => r.data),
  tasks: (view) => c.get("/tasks", { params: { view } }).then((r) => r.data),
  createTask: (b) => c.post("/tasks", b).then((r) => r.data),
  completeTask: (id) => c.post(`/tasks/${id}/complete`).then((r) => r.data),
  rescheduleTask: (id, due_date) => c.post(`/tasks/${id}/reschedule`, null, { params: { due_date } }).then((r) => r.data),
  dashboard: (params) => c.get("/dashboard", { params }).then((r) => r.data),
  settings: () => c.get("/settings").then((r) => r.data),
  notifications: () => c.get("/notifications").then((r) => r.data),
  readNotifications: () => c.post("/notifications/read").then((r) => r.data),
  exportUrl: () => `${API}/reports/leads.csv`,
  exportCsv: (params) => c.get("/reports/leads.csv", { params, responseType: "blob" }).then((r) => { const u = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = u; a.download = "plotbysquare_leads.csv"; a.click(); URL.revokeObjectURL(u); }),
  settingsUsage: () => c.get("/settings/usage").then((r) => r.data),
  performance: () => c.get("/reports/employee-performance").then((r) => r.data),
  updateSettings: (b) => c.put("/settings", b).then((r) => r.data),
  audit: () => c.get("/audit").then((r) => r.data),
  hr: {
    me: () => c.get("/hr/me").then((r) => r.data),
    dashboard: () => c.get("/hr/dashboard").then((r) => r.data),
    employees: (params) => c.get("/hr/employees", { params }).then((r) => r.data),
    employee: (id) => c.get(`/hr/employees/${id}`).then((r) => r.data),
    createEmployee: (b) => c.post("/hr/employees", b).then((r) => r.data),
    updateEmployee: (id, b) => c.put(`/hr/employees/${id}`, b).then((r) => r.data),
    settings: () => c.get("/hr/settings").then((r) => r.data),
    saveSettings: (b) => c.put("/hr/settings", b).then((r) => r.data),
    templates: () => c.get("/hr/templates").then((r) => r.data),
    saveTemplate: (k, b) => c.put(`/hr/templates/${k}`, b).then((r) => r.data),
    resetTemplate: (k) => c.delete(`/hr/templates/${k}`).then((r) => r.data),
    access: () => c.get("/hr/access").then((r) => r.data),
    setAccess: (id, hr_role) => c.put(`/hr/access/${id}`, { hr_role }).then((r) => r.data),
    createHrUser: (b) => c.post("/hr/access/users", b).then((r) => r.data),
    upload: (file, purpose) => { const fd = new FormData(); fd.append("file", file); fd.append("purpose", purpose); return c.post("/hr/upload", fd).then((r) => r.data); },
    fields: (b) => c.post("/hr/documents/fields", b).then((r) => r.data),
    preview: (b) => c.post("/hr/documents/preview", b, { responseType: "blob" }).then((r) => r.data),
    createDoc: (b) => c.post("/hr/documents", b).then((r) => r.data),
    docs: (params) => c.get("/hr/documents", { params }).then((r) => r.data),
    doc: (id) => c.get(`/hr/documents/${id}`).then((r) => r.data),
    regenerate: (id, b) => c.put(`/hr/documents/${id}`, b).then((r) => r.data),
    revise: (id, b) => c.post(`/hr/documents/${id}/revise`, b).then((r) => r.data),
    setStatus: (id, status, reason = "") => c.post(`/hr/documents/${id}/status`, null, { params: { status, reason } }).then((r) => r.data),
    file: (url) => c.get(url.replace(/^\/api\/crm/, ""), { responseType: "blob" }).then((r) => r.data),
    bulkSlips: (b) => c.post("/hr/documents/bulk-salary-slips", b).then((r) => r.data),
    emailDoc: (id) => c.post(`/hr/documents/${id}/email`).then((r) => r.data),
    digitalFile: (id) => c.get(`/hr/employees/${id}/file`).then((r) => r.data),
    onb: {
      list: (bucket) => c.get("/hr/onboarding", { params: { bucket } }).then((r) => r.data),
      notifications: () => c.get("/hr/onboarding/notifications").then((r) => r.data),
      create: (b) => c.post("/hr/onboarding", b).then((r) => r.data),
      get: (id) => c.get(`/hr/onboarding/${id}`).then((r) => r.data),
      reveal: (id) => c.get(`/hr/onboarding/${id}/reveal`).then((r) => r.data),
      regenerate: (id) => c.post(`/hr/onboarding/${id}/regenerate`).then((r) => r.data),
      revoke: (id) => c.post(`/hr/onboarding/${id}/revoke`).then((r) => r.data),
      send: (id) => c.post(`/hr/onboarding/${id}/send`).then((r) => r.data),
      file: (id, slot) => c.get(`/hr/onboarding/${id}/files/${slot}`, { responseType: "blob" }).then((r) => r.data),
      docStatus: (id, slot, b) => c.post(`/hr/onboarding/${id}/files/${slot}/status`, b).then((r) => r.data),
      requestCorrection: (id, items) => c.post(`/hr/onboarding/${id}/request-correction`, { items }).then((r) => r.data),
      reject: (id, reason) => c.post(`/hr/onboarding/${id}/reject`, { reason }).then((r) => r.data),
      approve: (id, resolutions) => c.post(`/hr/onboarding/${id}/approve`, { resolutions }).then((r) => r.data),
      zip: (id) => c.get(`/hr/onboarding/${id}/zip`, { responseType: "blob" }).then((r) => r.data),
      purge: (id, reason) => c.post(`/hr/onboarding/${id}/purge`, { reason }).then((r) => r.data),
    },
  },
  wm: {
    perms: () => c.get("/wm/permissions").then((r) => r.data),
    list: (params) => c.get("/wm/properties", { params }).then((r) => r.data),
    get: (id) => c.get(`/wm/properties/${id}`).then((r) => r.data),
    create: (b) => c.post("/wm/properties", b).then((r) => r.data),
    saveDraft: (id, b) => c.put(`/wm/properties/${id}/draft`, b).then((r) => r.data),
    discard: (id) => c.delete(`/wm/properties/${id}/draft`).then((r) => r.data),
    publish: (id) => c.post(`/wm/properties/${id}/publish`).then((r) => r.data),
    unpublish: (id) => c.post(`/wm/properties/${id}/unpublish`).then((r) => r.data),
    featured: (id, featured) => c.post(`/wm/properties/${id}/featured`, null, { params: { featured } }).then((r) => r.data),
    remove: (id) => c.delete(`/wm/properties/${id}`).then((r) => r.data),
    preview: (id) => c.get(`/wm/properties/${id}/preview`).then((r) => r.data),
    media: (params) => c.get("/wm/media", { params }).then((r) => r.data),
    history: (params) => c.get("/wm/history", { params }).then((r) => r.data),
    share: (b) => c.post("/wm/share", b).then((r) => r.data),
    upload: async (file, kind, propertyId, onProgress) => chunked("/wm/upload", file, { kind, property_id: propertyId || "" }, onProgress),
  },
  hc: {
    perms: () => c.get("/hc/permissions").then((r) => r.data),
    list: () => c.get("/hc/campaigns").then((r) => r.data),
    get: (id) => c.get(`/hc/campaigns/${id}`).then((r) => r.data),
    create: (b) => c.post("/hc/campaigns", b).then((r) => r.data),
    saveDraft: (id, b) => c.put(`/hc/campaigns/${id}/draft`, b).then((r) => r.data),
    discard: (id) => c.delete(`/hc/campaigns/${id}/draft`).then((r) => r.data),
    publish: (id, b = {}) => c.post(`/hc/campaigns/${id}/publish`, b).then((r) => r.data),
    act: (id, action) => c.post(`/hc/campaigns/${id}/${action}`).then((r) => r.data),
    order: (ids) => c.put("/hc/order", { ids }).then((r) => r.data),
    history: (params) => c.get("/hc/history", { params }).then((r) => r.data),
    analytics: () => c.get("/hc/analytics").then((r) => r.data),
    upload: (file, variant, onProgress) => chunked("/hc/upload", file, { variant }, onProgress),
  },
};
async function chunked(url, file, fields, onProgress) {
  const CHUNK = 4 * 1024 * 1024;
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const uploadId = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^a-zA-Z0-9-]/g, "");
  let res;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("file", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    Object.entries({ ...fields, upload_id: uploadId, index: i, total, filename: file.name }).forEach(([k, v]) => fd.append(k, v));
    res = await c.post(url, fd, { onUploadProgress: (e) => onProgress?.(Math.round(((i + (e.total ? e.loaded / e.total : 1)) / total) * 100)) });
  }
  return res.data;
}
export const CRM_API = API;
export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}
export default crm;
